import { useRecoilValue } from "recoil";
import { resetRecoil } from "recoil-nexus";
import styled from "styled-components";
import { eventState, EventStateType } from "../../recoil/event";
import { useEffect } from "react";

const RegionCluster = (oProps: any) => {
  const event = useRecoilValue<EventStateType>(eventState);

  const closeEvent = () => {
    resetRecoil(eventState);
  };

  useEffect(() => {
    if (!event.event_detail_url) resetRecoil(eventState);
  }, [event]);

  return (
    <Style>
      <div className="clusterWrap">
        {event.event_detail_url && (
          <img
            className="cluster"
            src={event.event_detail_url}
            alt="cluster_img"
          />
        )}
        <button className="closeModalButton" onClick={closeEvent}></button>
      </div>
    </Style>
  );
};
export default RegionCluster;

const Style = styled.div`
  .clusterWrap {
    width: 95vw;
    height: 95vh;
    border-radius: 20px;
    overflow: hidden;

    img.cluster {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .closeModalButton {
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 40px;
  }
`;
